// TODO --- Remove definitions when upgrading to TS >3.5
export type PermissionState = 'granted' | 'denied' | 'prompt';

export const PERMISSION_STATES: {
  [key in PermissionState]: PermissionState;
} = {
  granted: 'granted',
  denied: 'denied',
  prompt: 'prompt',
};
